import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_available_inventory_by_lotId_packagedId_warehouseIdService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { lotId: number, packagedId: number, warehouseId: number, eligibleForAllocationCheck?: boolean }): 
  Promise<{ result: { TotalAvailablePackagedAmount?: number, TotalAvailableBaseAmount?: number } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.lotId)) {
      missingRequiredInParams.push('\'lotId\'');
    }
    if (isNil(inParams.packagedId)) {
      missingRequiredInParams.push('\'packagedId\'');
    }
    if (isNil(inParams.warehouseId)) {
      missingRequiredInParams.push('\'warehouseId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SalesOrders/datasources/ds_get_available_inventory_by_lotId_packagedId_warehouseId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      lotId: number, packagedId: number, warehouseId: number, eligibleForAllocationCheck?: boolean    }) {
        if(isNil(inParams.lotId)) {
          return true; 
        }
        if(isNil(inParams.packagedId)) {
          return true; 
        }
        if(isNil(inParams.warehouseId)) {
          return true; 
        }
      return false;
    }
}
